import axios from "axios";
import { supabase } from "./supabase";

const rawBase = (process.env.REACT_APP_BACKEND_URL || "").trim();

// Development: use same-origin `/api` so the CRA dev server proxy (package.json "proxy")
// forwards to FastAPI — avoids browser CORS entirely.
// Production: set REACT_APP_BACKEND_URL to your deployed API origin (e.g. https://api.example.com).
let apiRoot;
if (process.env.NODE_ENV === "production") {
  // No warning needed: /api is handled by Nginx proxy manager in production
  apiRoot = rawBase ? `${rawBase.replace(/\/$/, "")}/api` : "/api";
} else {
  apiRoot = "/api";
}

export const API = apiRoot;

export const api = axios.create({
  baseURL: API,
  timeout: 10000, // 10s timeout to prevent infinite loading
});

api.interceptors.request.use(async (config) => {
  const devToken = localStorage.getItem("dev_bypass_token");
  if (devToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${devToken}`;
    return config;
  }
  
  // Wrap getSession in a timeout to prevent infinite hanging when the app wakes up
  const sessionPromise = supabase.auth.getSession();
  const timeoutPromise = new Promise((_, reject) => 
    setTimeout(() => reject(new Error("Supabase session timeout")), 8000)
  );
  
  const { data } = await Promise.race([sessionPromise, timeoutPromise]);
  const token = data?.session?.access_token;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
